module.exports = __webpack_public_path__ + "img/moeRegistration1.82eebe63.png";